exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-1-wrapper[data-v-1505eeee]{width:210px;padding-bottom:10px}.listing-img[data-v-1505eeee]{width:20px;height:20px;display:inline-block;margin-right:5px}", ""]);

// exports
